export default "__VITE_ASSET__B$K3GtUg__"